module.exports = __webpack_public_path__ + "images/gwt-quiz-background.jpg";